import { defineMessages } from "react-intl";
import { defaultFormMessages } from "../shared/crud/form";

const formMessages = defineMessages({
  id: {
    id: "",
    defaultMessage: "",
  },
  originPropertyTicker: {
    id: "createPropertyForm.label.originPropertyTicker",
    defaultMessage: "Ticker del hotel origen",
  },
  targetPropertyTicker: {
    id: "createPropertyForm.label.targetPropertyTicker",
    defaultMessage: "Ticker del hotel destino",
  },
  options: {
    id: "createPropertyForm.label.options",
    defaultMessage: "Opciones",
  },
  migrateAri: {
    id: "createPropertyForm.label.migrateAri",
    defaultMessage: "Migrar ARI",
  },
  migrateInventory: {
    id: "createPropertyForm.label.migrateInventory",
    defaultMessage: "Migrar Inventario",
  },
});

export const messages = {
  ...defaultFormMessages,
  ...formMessages,
  ...defineMessages({
    entityName: {
      id: "createProperty.entityName",
      defaultMessage: "Create Property",
    },
    save: { id: "default.clone", defaultMessage: "Clone" },
    successful: {
      id: "createProperty.toast.successful",
      defaultMessage:
        "Property cloning request sent. You should receive an email when process finish.",
    },
    ariRequiresInventory: {
      id: "replicateProperty.validation.ariRequiresInventory",
      defaultMessage: "Migrate ARI requires select the Migrate Inventory Lines option too",
    },
  }),
};
